module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_00.0d0de988.png";